const wordData = [
	'Ajanhukka',
	'Sivuviidakko',
	'Räiskyvä',
	'Ymmärrettävä',
	'JavaScript',
	'Hangaari',
	'Hidastelija',
	'Kestokangaskassi'
]
export default wordData